"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPageImage = exports.ErrorPageLogo = exports.LogoContainer = exports.Description = exports.HomeButton = exports.Row = exports.Col = exports.LinksWrapper = exports.ContentAreaContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Container_1 = __importDefault(require("../../UI/Container"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Button_1 = __importDefault(require("../../Button"));
const Typography_1 = __importDefault(require("../../UI/Typography"));
exports.ContentAreaContainer = (0, styled_components_1.default)(Container_1.default) `
  padding: ${props => props.theme.spacing.l1}px 0;
  height: ${props => props.theme.constants.blockWidth.xl1}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
exports.LinksWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${props => props.theme.spacing.s3}px;
`;
exports.Col = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.Row = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  width: 100%;
  height: inherit;
`;
exports.HomeButton = (0, styled_components_1.default)(Button_1.default) `
  margin-top: ${props => props.theme.spacing.m4}px;
`;
exports.Description = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  margin: 0;
  font-weight: ${props => props.theme.typography.weight.regular};

  > p {
    margin: 0;
  }
`;
exports.LogoContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;
exports.ErrorPageLogo = styled_components_1.default.img `
  width: ${props => props.theme.spacing.xl1}px;
  height: auto;
  pointer-events: none;
  margin-bottom: ${props => props.theme.spacing.s4}px;
`;
exports.ErrorPageImage = styled_components_1.default.img `
  pointer-events: none;
`;
exports.default = {
    ContentAreaContainer: exports.ContentAreaContainer,
    Col: exports.Col,
    Row: exports.Row,
    HomeButton: exports.HomeButton,
    Description: exports.Description,
    LogoContainer: exports.LogoContainer,
    ErrorPageLogo: exports.ErrorPageLogo,
    ErrorPageImage: exports.ErrorPageImage
};
